import { render, staticRenderFns } from "./proyectos.vue?vue&type=template&id=52627d14"
import script from "./proyectos.vue?vue&type=script&lang=js"
export * from "./proyectos.vue?vue&type=script&lang=js"
import style0 from "./proyectos.vue?vue&type=style&index=0&id=52627d14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports